export function isCaptureMode(search = window.location.search): boolean {
  return new URLSearchParams(search).get('capture') === '1'
}

export function captureStepLimit(search = window.location.search): number {
  const parsed = Number.parseInt(new URLSearchParams(search).get('capture_steps') ?? '', 10)
  return Number.isFinite(parsed) && parsed > 0 ? Math.min(parsed, 20) : 6
}
